var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 27,
    viewBox: "0 0 76 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9883 22H73.5003C74.8811 22 76.0003 23.1193 76.0003 24.5C76.0003 25.8807 74.8811 27 73.5003 27H72.9883V22Z",
    fill: "#5F2411"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00602 1C1.12611 1 0.671831 2.04721 1.2749 2.68538L5.94926 10.8064C6.31314 11.1915 6.31314 11.7921 5.94926 12.1772L1.2749 20.2982C0.671831 20.9364 1.12611 21.9836 2.00601 21.9836H76V6C76 3.23858 73.7524 1 70.9799 1L2.00602 1Z",
    fill: "url(#paint0_radial_11708_15268)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0157 21.9836C74.6651 21.9836 76.0022 23.3341 76.0022 25V21.9836H73.0157Z",
    fill: "url(#paint1_radial_11708_15268)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9743 22H72.9878C73.7486 22 74.443 22.2873 74.9703 22.7604C75.0488 22.8308 75.1236 22.9053 75.1943 22.9836C75.1992 22.9891 75.2041 22.9945 75.209 23C75.6848 23.5343 75.9743 24.2412 75.9743 25.0164V22ZM76 6C76 3.23858 73.7524 1 70.9799 1H1.00602C0.12611 1 -0.328169 2.04721 0.274899 2.68538L5.94926 10.8064C6.31314 11.1915 6.31314 11.7921 5.94926 12.1772L0.274899 20.2982C-0.328169 20.9364 0.126108 21.9836 1.00601 21.9836H76V6ZM74.996 20.9836V6C74.996 3.79086 73.1979 2 70.9799 2L1.00602 2L6.68038 10.121C7.40813 10.8912 7.40813 12.0925 6.68038 12.8626L1.00602 20.9836H74.996Z",
    fill: "#EF4B05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3879 8.16088C21.4742 8.16088 20.752 8.43388 20.2212 8.97988C19.6991 9.52588 19.4381 10.2842 19.4381 11.2549C19.4381 12.2082 19.7122 12.9622 20.2604 13.5169C20.8086 14.0715 21.5178 14.3489 22.3879 14.3489C23.1449 14.3489 23.8933 14.1105 24.6329 13.6339L25.2594 15.2459C24.3893 15.8352 23.3581 16.1299 22.166 16.1299C20.652 16.1299 19.4381 15.6922 18.5244 14.8169C17.6195 13.9415 17.167 12.7542 17.167 11.2549C17.167 9.73822 17.6064 8.54655 18.4853 7.67988C19.3728 6.81322 20.5997 6.37988 22.166 6.37988C23.3581 6.37988 24.3893 6.67455 25.2594 7.26388L24.6329 8.87588C23.8933 8.39922 23.1449 8.16088 22.3879 8.16088Z",
    fill: "#FEF7E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7448 6.50988V14.1669H32.7649V15.9999H26.4606V6.50988H28.7448Z",
    fill: "#FEF7E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1239 8.29088V10.2279H39.7394V11.9049H36.1239V14.2189H40.0004V15.9999H33.905V6.50988H40.0004V8.29088H36.1239Z",
    fill: "#FEF7E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6841 15.9999L43.908 6.50988H46.2574L49.4683 15.9999H47.1188L46.5576 13.9459H43.5425L42.9943 15.9999H40.6841ZM43.9993 12.2689H46.1138L45.0696 8.42088H45.0435L43.9993 12.2689Z",
    fill: "#FEF7E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4521 12.4899V15.9999H50.2724V6.57488C51.2296 6.44488 52.2737 6.37988 53.4049 6.37988C54.7102 6.37988 55.6804 6.62688 56.3156 7.12088C56.9595 7.60622 57.2815 8.29955 57.2815 9.20088C57.2815 9.78155 57.1118 10.3059 56.7724 10.7739C56.4331 11.2332 55.9849 11.5625 55.428 11.7619V11.7879C55.8805 12.0392 56.2503 12.5549 56.5375 13.3349L57.5425 15.9999H55.2584L54.3578 13.4259C54.2359 13.0619 54.088 12.8149 53.914 12.6849C53.74 12.5549 53.4702 12.4899 53.1047 12.4899H52.4521ZM52.4521 10.8649H53.1831C53.7922 10.8649 54.2577 10.7392 54.5796 10.4879C54.9016 10.2279 55.0626 9.86822 55.0626 9.40888C55.0626 8.50755 54.4665 8.05688 53.2744 8.05688C52.9612 8.05688 52.6871 8.08288 52.4521 8.13488V10.8649Z",
    fill: "#FEF7E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2526 0L12.1116 5.48884L16.7747 6.5L12.1116 7.51116L11.2526 13L10.3936 7.51116L5.73047 6.5L10.3936 5.48884L11.2526 0Z",
    fill: "#FACC54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4336 3L61.8241 5.53331L63.9437 6L61.8241 6.46669L61.4336 9L61.0431 6.46669L58.9235 6L61.0431 5.53331L61.4336 3Z",
    fill: "#FACC54"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4497 5L65.8402 7.53331L67.9597 8L65.8402 8.46669L65.4497 11L65.0592 8.46669L62.9396 8L65.0592 7.53331L65.4497 5Z",
    fill: "#FACC54"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11708_15268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4999 -0.500001) rotate(-0.830317) scale(69.0072 39.9736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EF7A05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6251,
    stopColor: "#DE5500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11708_15268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4999 -0.500001) rotate(-0.830317) scale(69.0072 39.9736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EF7A05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6251,
    stopColor: "#DE5500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.8ad114d29141fae0ea89637ea0e342c1.svg";
export { ForwardRef as ReactComponent };